import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BasketsService } from 'src/app/services/baskets.service';
import { ProductsService } from 'src/app/services/products.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { DialogDeleteBasketComponent } from 'src/app/components/dialogs/dialog-delete-basket/dialog-delete-basket.component';

@Component({
  selector: 'app-edit-basket',
  templateUrl: './edit-basket.component.html',
  styleUrls: ['./edit-basket.component.css']
})
export class EditBasketComponent implements OnInit {

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isLinear = false;

  basketID: string;
  basket: any = {};
  name = '';
  productsFromAPI: any = [];
  productsToShow: any = [];
  productsToSubmit = [];

  public pictureURL: string = '';
  private picture: File;

  constructor(private _formBuilder: FormBuilder, private basketsService: BasketsService, private productsService: ProductsService, private route: ActivatedRoute, private router: Router, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  ngOnInit() {
    this.route.paramMap.subscribe((paraMap: ParamMap) => {
      if (paraMap.has('id')) {
        this.basketID = paraMap.get('id');
      }
    });

    const reqBody = new FormData();
    reqBody.append('_id', this.basketID);

    this.productsService.getProductsAsAdmin().subscribe(result => {
      this.productsFromAPI = result.data;
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })

    this.firstFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      price: ['', Validators.required],
      picture: ['', Validators.required],
      subscriptionPrice: ['', Validators.required],
      enable: ['', Validators.required],
      code: ['', Validators.required],
      description: ['', Validators.required],
    });

    this.secondFormGroup = this._formBuilder.group({
      quantity: ['', Validators.required]
    });

    this.basketsService.getBasketAsAdmin(reqBody).subscribe(result => {
      if (result.success) {
        this.basket = result.data[0];
        this.pictureURL = result.data[0].picture;
        this.firstFormGroup = this._formBuilder.group({
          name: [result.data[0].name, Validators.required],
          price: [result.data[0].price, Validators.required],
          picture: ['', Validators.required],
          subscriptionPrice: [result.data[0].subscriptionPrice, Validators.required],
          enable: [result.data[0].enable, Validators.required],
          code: [result.data[0].code, Validators.required],
          description: [result.data[0].description, Validators.required],
        });
        this.productsToShow = result.data[0].products;
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onPictureSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.picture = file;

    this.pictureURL = URL.createObjectURL(file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (file) => {
      this.pictureURL = reader.result.toString();
    }
  }

  onAddProduct(ID, Name, Qty) {
    if (Qty === '') {
      this.snackBar.open('Quantity cannot be empty', 'Dismiss', {
        duration: 3000
      })
      return;
    } else if (Qty == 0) {
      this.snackBar.open('Quantity cannot be 0', 'Dismiss', {
        duration: 3000
      })
      return
    }

    const productToShow = {
      _id: ID,
      name: Name,
      quantity: Qty
    }

    this.productsToShow.push(productToShow);
  }

  onRemoveProduct(ID) {
    this.productsToShow = this.productsToShow.filter(product => product._id !== ID);
  }

  onSave() {

    this.productsToShow.map(product => {
      const updatedProduct = {
        _id: product._id,
        quantity: product.quantity
      }
      this.productsToSubmit.push(updatedProduct);
    });

    const basket = new FormData();
    basket.append('_id', this.basketID);
    basket.append('name', this.firstFormGroup.value.name);
    basket.append('picture', this.picture);
    basket.append('price', this.firstFormGroup.value.price);
    basket.append('subscriptionPrice', this.firstFormGroup.value.subscriptionPrice);
    basket.append('products', JSON.stringify(this.productsToSubmit));
    basket.append('enable', this.firstFormGroup.value.enable);
    basket.append('code', this.firstFormGroup.value.code);
    basket.append('description', this.firstFormGroup.value.description);

    this.basketsService.updateBasket(basket).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/baskets']);
        this.snackBar.open('Basket updated successfully!', 'Dismiss', {
          duration: 3000
        })
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onDelete() {
    this.dialog.open(DialogDeleteBasketComponent, {
      data: {
        _id: this.basketID
      }
    })
  }

  onCalcel() {
    this.router.navigate(['/admin/baskets']);
  }
}
